import React from 'react';
import LegalLayout from '../components/common/LegalLayout';

const TuitionPage = () => (
  <LegalLayout
    title="회비 안내"
    subtitle="ElectroWave Club은 학원이 아니므로 표준 수강료 대신, 학생과 멘토 매칭에 맞춘 1:1 견적으로 안내드립니다."
    helmetDescription="ElectroWave Club 회비 안내 — 60분 × 월 4회 단일 구성, 일반 기초 20만/응용 32만/AI 기초 36만/AI 응용 48만원. 멘토에게 직접 입금하는 1:1 매칭 모델."
    accentColor="#6366f1"
  >
    <h2>1. 회비는 어떻게 책정되나요?</h2>
    <p>
      현재 ElectroWave Club은 단순 매칭 형태로 운영됩니다. 모든 코스는 <strong>60분 × 월 4회(주 1회)</strong> 단일
      구성이며, 일괄 선납이 아닌 <strong>매월 선불 납부</strong> 방식입니다. 학생이 매칭된 멘토에게 직접 입금하며,
      클럽이 결제를 대행하거나 보관하지 않습니다. 회비는 다음 두 변수에 따라 등급이 정해집니다.
    </p>
    <ul>
      <li><strong>학습 단계</strong> — 기초 / 응용</li>
      <li><strong>도메인</strong> — 일반 (Java·React·DB 등) / AI (AI 코딩·자동화·LLM 활용)</li>
    </ul>
    <p>
      줌(Zoom) 기반 1시간 미팅은 <strong>실습·코드 리뷰·페어 프로그래밍 중심</strong>으로 운영됩니다. 기본 이론은
      사전 학습 자료(공식 문서 / 무료 강의 / 사전 안내 텍스트)와 비동기 메시지로 보완하므로, 1시간 미팅 안에
      이론 강의를 욱여넣지 않습니다. 추가로 학습량이 필요한 학생은 멘토와 협의해 회차를 추가할 수 있습니다
      (시간당 단가 기준, 별도 청구).
    </p>
    <p>
      학생에게는 별도의 교재비, 플랫폼 사용료, 입회비가 청구되지 않으며, 회비 전액은 멘토에게 직접
      지급됩니다. <strong>매칭 수수료는 멘토가 클럽에 납부</strong>하는 구조이므로 학생이 별도로 부담하지
      않습니다. 다만 첫 달 환불 시에는{' '}
      <a href="/refund-policy">환불 정책</a>에 따라 매칭 수수료 등 회수가 어려운 비용이 환불액에서
      차감될 수 있습니다.
    </p>

    <h2>2. 등급별 회비 (2026년 기준)</h2>
    <p>
      모든 등급은 <strong>60분 × 월 4회</strong> 동일 구성이며, 차이는 <strong>학습 단계와 도메인</strong>에서
      옵니다. 표시된 금액은 <strong>매월 납부 기준</strong>이며, 실제 금액은 멘토의 경력과 학생의 학습 목표를
      반영해 상담 후 학생-멘토 간 협의로 ±10% 내에서 조정될 수 있습니다.
    </p>
    <table>
      <thead>
        <tr>
          <th>구성</th>
          <th>대상 코스 예시</th>
          <th>시간당</th>
          <th>월 회비</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td data-label="구성">일반 기초</td>
          <td data-label="대상 코스 예시">Java 기초 / C / 데이터베이스 모델링</td>
          <td data-label="시간당">5만원</td>
          <td data-label="월 회비">20만원 / 월</td>
        </tr>
        <tr>
          <td data-label="구성">일반 응용</td>
          <td data-label="대상 코스 예시">React / TypeScript / Java 심화</td>
          <td data-label="시간당">8만원</td>
          <td data-label="월 회비">32만원 / 월</td>
        </tr>
        <tr>
          <td data-label="구성">AI 기초</td>
          <td data-label="대상 코스 예시">AI 코딩 입문 / 프롬프트 엔지니어링</td>
          <td data-label="시간당">9만원</td>
          <td data-label="월 회비">36만원 / 월</td>
        </tr>
        <tr>
          <td data-label="구성">AI 응용</td>
          <td data-label="대상 코스 예시">AI 워크플로우 자동화 / 멀티 에이전트 / 코드베이스 자동화</td>
          <td data-label="시간당">12만원</td>
          <td data-label="월 회비">48만원 / 월</td>
        </tr>
      </tbody>
    </table>
    <p>
      전체 진행 기간은 코스에 따라 보통 <strong>8주~16주</strong>입니다. 추가 회차가 필요하면 해당 등급의
      시간당 단가 기준으로 별도 청구되며, 단체·사내 단위 매칭은 아래 4번 항목을 참고해 주세요.
    </p>

    <h2>3. 결제 방법</h2>
    <ul>
      <li><strong>매월 4회차분 선불 납부</strong>가 기본입니다. 일괄 선납이 아닌, 그 달의 첫 정기 미팅
        시작 전까지 한 달치를 미리 입금합니다.</li>
      <li>매칭 확정 후 멘토가 안내하는 계좌로 <strong>학생이 직접 이체</strong>합니다. 납부 시점은
        멘토와 협의해 결정합니다.</li>
      <li>회비 환불은 진행한 회차에 따라 비례 정산됩니다 (3회차 후 25%, 4회차 후 환불 불가).
        자세한 기준은 <a href="/refund-policy">환불 정책</a>을 따릅니다.</li>
      <li>현재는 단순 매칭 구조로 운영되므로 <strong>플랫폼 결제·세금계산서 발행은 제공되지 않습니다.</strong></li>
      <li>카드 결제, 분할 결제, 사업자 청구 처리는 향후 백오피스가 도입되면 별도 안내 예정입니다.</li>
    </ul>

    <h2>4. 단체 / 사내 신청</h2>
    <p>
      신입·주니어 온보딩, 사내 스터디 위탁 운영 등 단체 단위 매칭도 가능합니다. 인원, 도메인, 일정,
      예산을 알려 주시면 별도로 안내드립니다. 다만 위에서 안내한 대로 현재는 세금계산서 발행을
      지원하지 않으므로, 사내 회계 처리가 필요한 경우 사전에 알려 주세요.
    </p>

    <h2>5. 환불 / 일정 변경</h2>
    <p>
      회비를 입금하셨더라도 첫 미팅 전 또는 진행 중 사유에 따라 환불·일시중지가 가능합니다. 자세한 기준은{' '}
      <a href="/refund-policy">환불 정책</a> 페이지에서 확인해 주세요. 학생-멘토 간 직접 입금 구조이므로
      환불도 멘토가 학생에게 직접 송금합니다.
    </p>
  </LegalLayout>
);

export default TuitionPage;
